import React from 'react';
import { useTranslation } from 'react-i18next';
import { RM3_DETAILS_SOURCE, RM3_SIZE_UNIT } from 'arbitrip-common/client/utils/HotelDealsRm3';

import { IconBed, IconSize, IconSleeps } from './Rm3Icons';

const SIZE_KEYS = {
    [RM3_SIZE_UNIT.SQUARE_METRES]: 'HotelDealsRm3.SizeM2',
    [RM3_SIZE_UNIT.SQUARE_FEET]: 'HotelDealsRm3.SizeFt2',
};

/**
 * Specs line (spec §3.3): size only from a catalog carrier, sleeps from the carrier, and the bed only for a
 * one-card container (with more cards the bed sits under each card sub-heading). Bed text is an engine/supplier
 * string, untranslated.
 */
function Rm3RoomSpecs({ details, bedText }) {
    const { t } = useTranslation();
    const size = details.source === RM3_DETAILS_SOURCE.CATALOG ? details.size : null;
    const sizeKey = size && SIZE_KEYS[size.unit];
    const hasSleeps = details.sleeps !== null && details.sleeps !== undefined;

    if (!sizeKey && !hasSleeps && !bedText) {
        return null;
    }

    return (
        <div className="rm3-specs" data-testid="rm3-room-specs">
            {sizeKey && (
                <span className="rm3-specs__item">
                    <IconSize />
                    <span dir="ltr">{t(sizeKey, { value: size.value })}</span>
                </span>
            )}
            {hasSleeps && (
                <span className="rm3-specs__item">
                    <IconSleeps />
                    {t('HotelDealsRm3.Sleeps', { count: details.sleeps })}
                </span>
            )}
            {bedText && (
                <span className="rm3-specs__item">
                    <IconBed />
                    <bdi>{bedText}</bdi>
                </span>
            )}
        </div>
    );
}

export default Rm3RoomSpecs;
